import app from "nystem";
import { useEffect } from "react";
import { ContentTypeRender, Wrapper } from "nystem-components";

const ViewButtonDebugAndClear = ({ model, path }) => {
  useEffect(() => {
    setTimeout(() => {
      throw new Error(
        `Clear browser ${app().settings.version} ${navigator.userAgent}`
      );
    }, 100);
  }, []);

  const doByType = {
    clearAndReload: () => app().event("clearCacheAndReload"),
    reload: () => window.reload(),
  };

  return (
    <Wrapper onClick={doByType[model.viewActionType]}>
      <ContentTypeRender path={path} items={model.item} />
    </Wrapper>
  );
};

export default ViewButtonDebugAndClear;
